import React from "react";
import About from "../components/Components/About/About";
import Footer from "../components/Components/Footer/Footer";
import Contact from "../components/Components/Contact/Contact";
import PageContainer from "../components/Components/PageContainer/PageContainer";
import Underconstruct from "../components/Components/Underconstruct/Underconstruct";

function UnderconstructPage() {
  return <Underconstruct />;
}

export default UnderconstructPage;
